import React from "react"
import {
	BillEvent,
	getBillEventId,
	getBillEventLinkFields,
	getBillEventPayload,
	getBillEventTypeDisplay,
} from "../../resources/bills"
import {DataTableCell, DataTableRow} from "../DataTable/DataTable"
import IdLink from "../IdLink/IdLink"

interface BillEventRowProps {
	event: BillEvent
	onClick: () => void
}

export function BillEventRow({event, onClick}: BillEventRowProps) {
	const payload = getBillEventPayload(event)
	const payloadKeys = Object.keys(payload)
	const {accountId, paymentId, transactionId} = getBillEventLinkFields(event)

	return (
		<DataTableRow onClick={onClick}>
			<DataTableCell className="data-table-id">{getBillEventId(event)}</DataTableCell>
			<DataTableCell>{getBillEventTypeDisplay(event)}</DataTableCell>
			<DataTableCell className="bill-event-payload-cell">
				{payloadKeys.length > 0 ? `${payloadKeys.length} field${payloadKeys.length === 1 ? "" : "s"}` : "--"}
			</DataTableCell>
			<DataTableCell>
				{accountId ? (
					<IdLink className="data-table-id" href={`/accounts/${accountId}`}>
						{accountId}
					</IdLink>
				) : (
					"--"
				)}
			</DataTableCell>
			<DataTableCell>
				{paymentId ? (
					<IdLink className="data-table-id" href={`/payments/${paymentId}`}>
						{paymentId}
					</IdLink>
				) : (
					"--"
				)}
			</DataTableCell>
			<DataTableCell>
				{transactionId && accountId ? (
					<IdLink className="data-table-id" href={`/transaction/${accountId}/${transactionId}`}>
						{transactionId}
					</IdLink>
				) : transactionId ? (
					transactionId
				) : (
					"--"
				)}
			</DataTableCell>
		</DataTableRow>
	)
}
